import { Component, OnInit } from "@angular/core";
import { UsersService } from "src/app/users/users.service";
import { NgxSpinnerService } from "ngx-spinner";
import { LocalStorage } from "@ngx-pwa/local-storage";
import { ReportsService } from "../reports.service";

@Component({
    selector: "app-medals",
    templateUrl: "./medals.component.html",
    styleUrls: ["./medals.component.scss"],
})
export class MedalsComponent implements OnInit {
    public medals: any = null;

    constructor(
        private spinner: NgxSpinnerService,
        private reportsService: ReportsService
    ) {
        this.spinner.show();
        this.getMedal();
    }

    ngOnInit() {}

    getMedal() {
        this.reportsService.getMedal().subscribe((res) => {
            this.medals = res;

            setTimeout(() => {
                this.spinner.hide();
            }, 500);
        });
    }
}
